import { render, staticRenderFns } from "./customer-instruments.vue?vue&type=template&id=d9009ec2&"
import script from "./customer-instruments.vue?vue&type=script&lang=js&"
export * from "./customer-instruments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports